module.exports = __webpack_public_path__ + "img/pr-11.e0d67e98.png";